












import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapMutations } from "vuex";

@Component
export default class My extends Vue {
    private loading = false;
    private editForm: any = {
        infoType: 1,
        data: this.$store.state.userInfo.nickName
    };

    // 提交
    onSave() {
        this.$apis.putUserInfo(this.editForm)
            .then((res: any) => {
                
                this.$store.state.userInfo.nickName = this.editForm.data;
                this.$message({
                    type: 'success',
                    message: '提交成功!'
                });                    
            });
    }
}
